<template>
  <div id="succeed">
    <div id="succeed-passwoed">
      <div class="logo"><img src="../../assets/img/success.png" alt=""></div>
      <div class="succeed-ok">密码修改成功</div>
    </div>
  <p @click="toshow">返回</p>
    <div class="full">({{net}}秒后自动返回)</div>
  </div>
</template>
<script>
export default {
  name: "succeed",
  data(){
    return {
      show:0,
net:5
    }
  },
  mounted(){
this.Tonext()
  },
  methods:{
         Tonext(){
      var time= setInterval(()=>{
           this.net--
           if(this.net<1){
              this.$emit("itemShow",this.show);
              clearInterval(time)
           }
       },1000)
       
         },
         toshow(){
         this.$emit("itemShow",this.show);
         }
  }
};
</script>
<style lang="less" scoped>
#succeed {
  width: 100%;
  height: 100%;

  #succeed-passwoed {
    margin-top: 80rem;
    display: flex;
    justify-content: center;
    align-items: center;
      margin-bottom: 55rem; 
  
    .logo {
     width: 32px;
     height: 32px;
    //  margin-right: 10rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .succeed-ok {
    
      line-height: 28rem;
      margin-left: 25rem;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
    }
  }
  p {
    font-size: 14px;
    color: #0d94ff;
text-align: center;
margin-left: 5rem;
  }
  .full{
text-align: center;
font-size: 14px;
color:  #999999;
margin-bottom: 69rem;
margin-left: 10rem;

  }
}
</style>